// import * as csstips from 'csstips'
import {style} from 'typestyle'

export const CategoryRecommendPage = style({
    display: 'block',
    background: '#F4F4F4',
    minHeight: '100vh',
    overflow: 'hidden'
})

export const CategoryMenuItemFlexed = style({
    bottom: 50,
    // boxShadow: '0 2px 8px 0 #F0F0F0',
    display: 'block',
    height: 48,
    maxWidth: 480,
    // position: 'fixed',
    // top: 0,
    width: '100%',
    zIndex: 150
})



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendPage/CategoryRecommendPage.style.ts